import type { Account } from "@nwt/norce-pwa/dist/runtime/types/api/account/account";
import { defineStore, acceptHMRUpdate } from "pinia";

interface State {
	user: Account | null;
}

export const userStore = defineStore({
	id: "userStore",
	state: (): State => ({
		user: null
	}),
	actions: {
		async setUser(value: Account | null) {
			this.user = value;
			await useWishlistStore().updateWishlistOnLogIn();
		}
	},
	getters: {
		getUser: (state) => state.user
	},
	persist: [{ storage: persistedState.localStorage, paths: ["user"] }]
});
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(userStore, import.meta.hot));
}
